'use client';

import { Switch } from '@base-ui/react/switch';
import cn from 'classnames';
import type { ChangeEvent, ComponentProps } from 'react';

import styles from './SwdSwitch.module.scss';

export type SwdSwitchProps = Omit<ComponentProps<typeof Switch.Root>, 'onCheckedChange'> & {
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onCheckedChange?: ComponentProps<typeof Switch.Root>['onCheckedChange'];
};

export function SwdSwitch({ className, onChange, onCheckedChange, name, ...props }: SwdSwitchProps) {
  return (
    <Switch.Root
      className={cn(styles.switch, className)}
      name={name}
      {...props}
      onCheckedChange={(checked, details) => {
        onCheckedChange?.(checked, details);
        onChange?.({
          target: { name: name ?? '', checked: Boolean(checked) },
        } as ChangeEvent<HTMLInputElement>);
      }}
      data-slot="switch"
    >
      <Switch.Thumb className={styles.thumb} />
    </Switch.Root>
  );
}
